import React, { useContext, useState } from 'react';
import { Image } from '../../AbstractElements';
import CheckContext from '../../_helper/customizer/index';

const SidebarIcon = () => {
  const { toggleSidebar } = useContext(CheckContext);
  const [toggle, setToggle] = useState(false);
  const openCloseSidebar = () => {
    setToggle(!toggle);
    toggleSidebar(toggle);
  };

  const hotelLogo = localStorage.getItem('hotelLogo');

  return (
    <div className="logo-wrapper">
      <a href="">
        <Image
          attrImage={{
            className: 'img-fluid for-light',
            src: hotelLogo,
            alt: 'Hotel Logo',
          }}
        />
      </a>
      <div className='back-btn' onClick={() => openCloseSidebar()}><i className='fa fa-angle-left'></i></div>
    </div>
  );
};
export default SidebarIcon;